import { logoutUser, flashMessage } from ".";
import { Rule, FlashMessageType } from "../types";
import { Dispatch } from "redux";

const processError = (dispatch: Dispatch, error): void => {
	if (error.hasOwnProperty("message")) {
		if (error.response) {
			if (error.response.status !== 401 && error.response.status !== 400) {
				dispatch(flashMessage(error.message, FlashMessageType.ERROR, 5));
			}
		}

		return;
	}

	if (error.response) {
		switch (error.response.status) {
			case 400: {
				//silently fail
				console.log({ error });
				break;
			}

			case 401: {
				logoutUser(dispatch);
				return;
			}

			default: {
				dispatch(flashMessage(error.response.data, FlashMessageType.ERROR, 5));
				//alert(error.response.data);
				return;
			}
		}
	} else {
		if (error.name === "AbortError") {
			//ignore
		} else {
			console.log({ error });
		}
	}
};

export default processError;

export function extractDurations(rules: Rule[]): number[] {
	return rules.map((rule) => rule.duration);
}

export function filterUnique(a: any[]): any[] {
	return [...new Set(a)];
}

export function displayCardNetwork(network?: string): string | null {
	return network
		?.split("_")
		.map((s) => s?.trim())
		.map((s) => s.charAt(0).toUpperCase() + s.slice(1))
		.join(" ");
}
